import React from 'react';
import PropTypes from 'prop-types';
import TextField from '../BaseComponent/TextField';
import FieldContainer from '../BaseComponent/FieldContainer';

const Email = ({ field, label, propsFromForm, textClassName, ...props }) => {
  return (
    <FieldContainer>
      <TextField
        field={field}
        label={label}
        propsFromForm={propsFromForm}
        textClassName={textClassName}
        type="email"
        {...props}
      />
    </FieldContainer>
  );
};

Email.propTypes = {
  field: PropTypes.object.isRequired,
  label: PropTypes.string,
  propsFromForm: PropTypes.object,
  textClassName: PropTypes.string,
};

export default Email;
